function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
  id: "radialGradient3202",
  cx: 121.25,
  cy: 97.589,
  r: 77.917,
  fx: 141.25,
  fy: 77.589,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#f0f0f0",
  offset: 0
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#ff8330",
  offset: 1
})));
var _ref3 = /*#__PURE__*/React.createElement("g", {
  transform: "matrix(.94947 0 0 .94948 496.95 38.627)"
}, /*#__PURE__*/React.createElement("path", {
  transform: "translate(-25.833 3.3333)",
  d: "m199.17 97.589a77.917 77.917 0 1 1-155.83 0 77.917 77.917 0 1 1 155.83 0z",
  fill: "url(#radialGradient3202)"
}));
function SvgDiscover(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.22264 0 0 .22264 -.47704 94.829)"
  }, _ref3, /*#__PURE__*/React.createElement("g", {
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("text", {
    x: -9.8425188,
    y: 193.30708,
    fontFamily: "Verdana",
    fontWeight: "bold",
    style: {
      lineHeight: "0%"
    },
    xmlSpace: "preserve"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -9.8425188,
    y: 193.30708,
    fontSize: "220px",
    style: {
      lineHeight: 1.25
    }
  }, "Disc")), /*#__PURE__*/React.createElement("text", {
    x: 655.51172,
    y: 193.41451,
    fontFamily: "Verdana",
    fontWeight: "bold",
    style: {
      lineHeight: "0%"
    },
    xmlSpace: "preserve"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 655.51172,
    y: 193.41451,
    fontSize: "220px",
    style: {
      lineHeight: 1.25
    }
  }, "ver")), /*#__PURE__*/React.createElement("text", {
    x: 1043.307,
    y: 69.291351,
    fontFamily: "'Bitstream Vera Sans'",
    style: {
      lineHeight: "0%"
    },
    xmlSpace: "preserve"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 1043.307,
    y: 69.291351,
    fontSize: "40px",
    style: {
      lineHeight: 1.25
    }
  }, "\xAE")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscover);
export default __webpack_public_path__ + "static/media/discover.44274e45.svg";
export { ForwardRef as ReactComponent };